import { observer } from 'mobx-react-lite'
import controller from './spin.controller'
import { Spin } from 'antd'
import './spin.less'
import { LoadingOutlined } from '@ant-design/icons'

export const Spinner = observer(() => {
    return controller.spin ? <div className="spin"><Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} /></div> : <></>
})